/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInvoiceEditAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2v20h6v-2H6V4h7v5h5v1h2V7.586L14.414 2zm12.586 5H15V5.414zM8 9h3V7H8zm0 2h6v2h-4v1h2v2h-2v2H8zm13.707 4.293-3-3a1 1 0 0 0-1.414 0L12 17.586V22h4.414l5.293-5.293a1 1 0 0 0 0-1.414zM18 14.414 19.586 16l-4 4H14v-1.586z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInvoiceEditAlt as InvoiceEditAlt };
